import { defineStore } from 'pinia';

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    show: false,
    message: '',
    color: 'success',
    timeout: 3000,
  }),

  actions: {
    success(message) {
      this.message = message;
      this.color = 'success';
      this.show = true;
    },
    error(message) {
      this.message = message;
      this.color = 'error';
      this.timeout = 5000;
      this.show = true;
    },
    info(message) {
      this.message = message;
      this.color = 'info';
      this.show = true;
    },
  },
});
